/**
 * Full-screen message with an optional action. Used for the failure states a
 * WebView screen has to handle on its own: no network, expired session, an API
 * that answered with an error.
 */
export function ScreenMessage({
  title,
  description,
  actionLabel,
  onAction,
}: {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-4 py-12 text-center">
      <p className="text-18 font-bold">{title}</p>
      {description === undefined ? null : (
        <p className="text-14 text-light-gray-3" data-selectable="true">
          {description}
        </p>
      )}
      {actionLabel === undefined || onAction === undefined ? null : (
        <button
          type="button"
          onClick={onAction}
          className="text-16 mt-4 h-btn-sm rounded-pill border-2 border-primary px-8 font-bold text-primary"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
